module.exports = __webpack_public_path__ + "img/pickup point.4989a669.svg";